import { defineStyleConfig } from "@chakra-ui/react";

export const selectTheme = defineStyleConfig({
   variants: {
      outline: {
         field: {
            bgColor: "white",
            borderRadius: "none",
            borderColor: "brandBlue.400",
            borderWidth: "2px",
            height: "52px",
            fontSize: { base: 16 },
            px: { base: "24px" },
            color: "rgba(7, 51, 90, 0.5)",
            _hover: {
               borderColor: "brandBlue.500",
            },
            _focus: {
               borderColor: "brandBlue.400",
            },
         },
      },
   },
   defaultProps: {},
});
